import { useQuery } from '@apollo/client';
import { graphql } from '../gql';
import { CoverageFilterInput } from '../gql/graphql';
import { toPagination } from './utils';

export const GET_LOSS_PAYMENT_COVERAGES = graphql(`
  query getLossPaymentCoverages(
    $filters: CoverageFilterInput!
    $pagination: PaginationRequest
  ) {
    lossPaymentCoverages(filters: $filters, pagination: $pagination) {
      pageInfo {
        totalResults
        pageNumber
        pageSize
        hasNextPage
        hasPreviousPage
      }
      edges {
        node {
          uuid
          name
          order
          coverages {
            uuid
            name
            subCoverages {
              edges {
                node {
                  uuid
                  name
                }
              }
            }
          }
        }
      }
    }
  }
`);

export interface IUseLossPaymentCoveragesQueryArgs {
  pageNumber?: number;
  pageSize?: number;
  filters: CoverageFilterInput;
  skip?: boolean;
}

export function useLossPaymentCoveragesQuery({
  pageNumber,
  pageSize,
  filters,
  skip = false,
}: IUseLossPaymentCoveragesQueryArgs) {
  const { loading, data, error, refetch } = useQuery(
    GET_LOSS_PAYMENT_COVERAGES,
    {
      variables: {
        filters,
        pagination: toPagination(pageNumber, pageSize),
      },
      fetchPolicy: 'no-cache',
      skip,
    }
  );

  return {
    loading,
    error,
    data,
    refetch,
  };
}
